/**
 * @file index.tsx
 * @description Exports TriggerButton container component
 */
import TriggerButtonContainer from "./TriggerButtonContainer";

export { TriggerButtonContainer as TriggerButton };
export type { TriggerButtonContainerProps as TriggerButtonProps } from "./TriggerButtonContainer";
export default TriggerButtonContainer;
